import React from 'react';
import type PlanReleasesType from '@atlassian/jira-spa-apps-advanced-roadmaps-plan/src/ui/plan-releases/index-old.tsx';
import { markAsProductBundleReady } from '@atlassian/jira-spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

/**
 * Plan Releases page
 */
// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
export const LazyPlanReleases = lazyForPaint<typeof PlanReleasesType>(
	() =>
		markAsProductBundleReady(
			import(
				/* webpackChunkName: "async-plan-releases", jiraSpaEntry: "async-plan-releases" */ '@atlassian/jira-spa-apps-advanced-roadmaps-plan/src/ui/plan-releases/index-old.tsx'
			),
		),
	{ ssr: false },
);

const AsyncPlanReleases = (): React.JSX.Element => (
	<LazyPage Page={LazyPlanReleases} pageId="plan-releases" shouldShowSpinner />
);

export default AsyncPlanReleases;
